export default "__VITE_ASSET__CAr7FEOY__"